import * as actionTypes from '../actions/actionTypes';

const initialState = {
  summary: null,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ENREGISTRER_ACCUEIL_SUMMARY:
      return { ...state, summary: action.summary || null };
    case actionTypes.CHARGEMENT_ACCUEIL:
      return {
        ...state,
        loading: action.loading,
        ...(action.loading ? { summary: null } : {}),
      };
    default:
      return state;
  }
};

export default reducer;
